import React from 'react'

export default function Document (props) {
  return (
    <a
      href={props.url}
      target={props.target}
      key={props.id}
      className="dm-documents-table__row"
      download={!props.target}
    >
      <div className="dm-documents-table__row-title-container column-name">
        <div className="dm-documents-table__row-icon">
          <img src={props.icon.src} alt={props.icon.alt} />
        </div>
        <div className="dm-documents-table__row-title">{props.filename}</div>
      </div>
      <div className="dm-documents-table__row-date column-date">{props.dateString}</div>
      <div className="dm-documents-table__row-size column-size">{props.filesizeString}</div>
      <div className="dm-documents-table__row-download column-download"><div className="dm-download-icon" /></div>
    </a>
  )
}
